import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    variant: 'odds',
  },
  buttonBaseSpanProps: {
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
    textTransform: 'uppercase',
    fontWeight: 'extrabold',
    fontFamily: 'body',
    fontSize: '2xs',
    top: 'px',
  },
  buttonBaseBox: {
    fontSize: 'xs',
    fontWeight: 'extrabold',
    fontFamily: 'body',
  },
  textBase: {
    textAlign: 'center',
    color: 'blackAlpha.800',
  },
};
